module.exports = __webpack_public_path__ + "static/photoshoot-2-28b6602b0f89970771f1ba948fdd84d2.jpg";